import React from 'react';

const CommonDropdownWithStaticList = ({ ListData, value, onChange, label }) => {
    return (
        <div>
            <label
            htmlFor="saral_id"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            {label}
          </label>
            <select
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
                id="state-select"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Select {label}</option>
                {ListData?.length !== 0 &&
                    ListData?.map(({ id, name }) => (
                        <option key={id} value={id}>
                            {name}
                        </option>
                    ))}
            </select>
        </div>
    );
};

export default CommonDropdownWithStaticList;